module.exports = __webpack_public_path__ + "img/lowerabs-endomorph-female.a025576e.svg";